import { useId, type ReactElement, type RefObject } from 'react';

import { Button } from '@/components/ui/Button';
import { CoachMark } from '@/components/ui/coach-mark';
import { hasSeenCoachMark, markCoachMarkSeen } from '@/features/coach-marks';

import { APP_ACCESS_SWITCH_COACH_MARK } from './app-access-coach-mark';

export const AppAccessSwitchCoachMark = ({
  children,
  returnFocusRef,
}: {
  children: ReactElement;
  returnFocusRef: RefObject<HTMLElement | null>;
}) => {
  const id = useId();
  const mark = APP_ACCESS_SWITCH_COACH_MARK;

  return (
    <CoachMark.Root
      defaultOpen={!hasSeenCoachMark(mark)}
      onOpenChange={(open) => {
        if (!open) markCoachMarkSeen(mark);
      }}
    >
      <CoachMark.Anchor asChild>{children}</CoachMark.Anchor>
      <CoachMark.Content
        side="bottom"
        align="end"
        width={mark.width}
        aria-labelledby={`${id}-title`}
        aria-describedby={`${id}-description`}
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          returnFocusRef.current?.focus();
        }}
      >
        <CoachMark.Title id={`${id}-title`}>{mark.title}</CoachMark.Title>
        <CoachMark.Description id={`${id}-description`}>
          {mark.description}
        </CoachMark.Description>
        <CoachMark.Footer>
          <CoachMark.Dismiss asChild>
            <Button size="sm">Got it</Button>
          </CoachMark.Dismiss>
        </CoachMark.Footer>
      </CoachMark.Content>
    </CoachMark.Root>
  );
};
